import {NgModule} from '@angular/core';
import {HeaderComponent} from "./header/header.component";
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular/lazy";
import {FooterComponent} from "./footer/footer.component";
import {PasswordMeterComponent} from "./password-meter/password-meter.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BlockTextComponent} from "./block-text/block-text.component";
import {BlockVideoComponent} from "./block-video/block-video.component";
import {BlockHighlightComponent} from "./block-highlight/block-highlight.component";
import {BlockChatComponent} from "./block-chat/block-chat.component";
import {BlockRateFeedbackComponent} from "./block-rate-feedback/block-rate-feedback.component";
import {BlockDiscoverArticlesComponent} from './block-discover-articles/block-discover-articles.component'
import {RouterLink} from '@angular/router'
import {CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {TranslationComponent} from "./translation/translation.component";
import {LinkHandlerDirective} from "../directives/link-handler.directive";
import {ModalPageComponent} from "./modal-page/modal-page.component";
import { EntryDetailsComponent } from './entry-details/entry-details.component'
import {LangSwitcherComponent} from "./lang-switcher/lang-switcher.component";
import {BlockGuideRateFeedbackComponent} from "./block-guide-rate-feedback/block-guide-rate-feedback.component";
import {RiskAssessmentCardComponent} from "./risk-assessment-card/risk-assessment-card.component";
import {MobileHeaderBannerComponent} from "./mobile-header-banner/mobile-header-banner.component";
import {BlockRecommendedArticlesComponent} from "./block-recommended-articles/block-recommended-articles.component";
import {BlockRecommendedGuidesComponent} from "./block-recommended-guides/block-recommended-guides.component";
import {TitleBarComponent} from "./title-bar/title-bar.component";
import {FooterBannerComponent} from "./footer-banner/footer-banner.component";
import {GuideCardComponent} from "./guide-card/guide-card.component";
import {ResourceCardComponent} from "./resource-card/resource-card.component";
import {SeeMoreCardComponent} from "./see-more-card/see-more-card.component";
import {LiveIncidentBannerComponent} from "./live-incident-banner/live-incident-banner.component";
import {GuideSectionComponent} from "./guide-section/guide-section.component";
import {BookmarksLinkCardComponent} from "./bookmarks-link-card/bookmarks-link-card.component";
import {CompleteDetailsBannerComponent} from "./complete-details-banner/complete-details-banner.component";
import {CompleteDetailsModalComponent} from "./complete-details-modal/complete-details-modal.component";
import {CrimeTypePickerComponent} from "./crime-type-picker/crime-type-picker.component";

@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        PasswordMeterComponent,
        BlockTextComponent,
        BlockVideoComponent,
        BlockHighlightComponent,
        BlockChatComponent,
        BlockRateFeedbackComponent,
        BlockDiscoverArticlesComponent,
        BlockRecommendedArticlesComponent,
        BlockRecommendedGuidesComponent,
        TranslationComponent,
        ModalPageComponent,
        EntryDetailsComponent,
        LangSwitcherComponent,
        BlockGuideRateFeedbackComponent,
        RiskAssessmentCardComponent,
        LinkHandlerDirective,
        MobileHeaderBannerComponent,
        TitleBarComponent,
        FooterBannerComponent,
        GuideCardComponent,
        ResourceCardComponent,
        SeeMoreCardComponent,
        LiveIncidentBannerComponent,
        GuideSectionComponent,
        BookmarksLinkCardComponent,
        CompleteDetailsBannerComponent,
        CompleteDetailsModalComponent,
        CrimeTypePickerComponent
    ],
    exports: [
        HeaderComponent,
        FooterComponent,
        PasswordMeterComponent,
        BlockTextComponent,
        BlockVideoComponent,
        BlockHighlightComponent,
        BlockChatComponent,
        BlockRateFeedbackComponent,
        BlockDiscoverArticlesComponent,
        BlockRecommendedArticlesComponent,
        BlockRecommendedGuidesComponent,
        TranslationComponent,
        ModalPageComponent,
        EntryDetailsComponent,
        LangSwitcherComponent,
        BlockGuideRateFeedbackComponent,
        RiskAssessmentCardComponent,
        MobileHeaderBannerComponent,
        TitleBarComponent,
        FooterBannerComponent,
        GuideCardComponent,
        ResourceCardComponent,
        SeeMoreCardComponent,
        LiveIncidentBannerComponent,
        GuideSectionComponent,
        BookmarksLinkCardComponent,
        CompleteDetailsBannerComponent,
        CompleteDetailsModalComponent,
        CrimeTypePickerComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        RouterLink,
        ReactiveFormsModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class ComponentsModule {

}
